// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__gnx28","title":"pagination_title__InKdJ","button":"pagination_button__gYVl7"};